import { useState } from "react";
import { toast } from "sonner";
import { Coffee, Check } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function MugCheer({ postId, t }) {
  const { user, refreshUser } = useAuth();
  const [s, setS] = useState(t);
  const [busy, setBusy] = useState(false);
  const own = user?.user_id === s.for;
  const cheer = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/mug-thanks/${postId}`);
      setS({ ...s, count: data.count, mine: true });
      toast.success(`Danke gesagt ☕ +${data.points} Punkte`);
      refreshUser?.();
    } catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  const label = s.count === 1 ? "1 Mitglied sagt Danke" : `${s.count} Mitglieder sagen Danke`;
  return (
    <div className="rounded-2xl bg-gradient-to-r from-[#1a1206] to-[#2a1d08] ring-1 ring-amber-300/30 p-3 flex items-center gap-3" data-testid={`mug-cheer-${postId}`}>
      <span className={`w-10 h-10 shrink-0 rounded-full flex items-center justify-center bg-gradient-to-br from-amber-200 to-amber-500 text-[#3a2508] ${s.mine ? "" : "animate-pulse"}`}><Coffee className="w-5 h-5" /></span>
      <p className="flex-1 min-w-0 text-xs text-amber-100/90" data-testid={`mug-cheer-count-${postId}`}>{s.count ? label : "Sei die erste Person, die Danke sagt!"}</p>
      {own ? <span className="text-xs font-bold text-amber-300">Das ist für dich 💛</span>
        : s.mine ? <span className="h-9 px-3.5 rounded-full bg-white/10 text-amber-200 text-xs font-bold inline-flex items-center gap-1" data-testid={`mug-cheer-done-${postId}`}><Check className="w-3.5 h-3.5" /> Gesagt</span>
          : <button type="button" onClick={cheer} disabled={busy || !user} className="h-9 px-4 rounded-full bg-gradient-to-r from-amber-300 to-amber-500 text-[#3a2508] text-xs font-black inline-flex items-center gap-1.5 active:scale-95 transition-transform disabled:opacity-50" data-testid={`mug-cheer-btn-${postId}`}><Coffee className="w-3.5 h-3.5" /> Danke sagen</button>}
    </div>
  );
}
